export const DEFAULT_DIALOG_OPTIONS = {
  width: '400px'
}
